import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Brand";
import { scrollToId } from "../lib/site";

const LINKS = [
  ["story", "The Book"],
  ["tip", "Leave a Tip"],
  ["wall", "Reader Notes"],
  ["share", "Share"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };
  return (
    <header data-testid="nav-header" className="fixed top-0 inset-x-0 z-50 border-b border-[#e3ba73]/10 bg-[#121016]/80 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-3 group">
          <Logo size={30} animate />
          <span className="font-serif-d text-lg sm:text-xl tracking-wide">Bipolar Is Who I Am</span>
        </Link>
        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map(([id, label]) => (
            <button key={id} data-testid={`nav-${id}-link`} onClick={() => go(id)}
              className="text-sm text-[#c4bbb0] hover:text-[#f4ede2] transition-colors duration-300">
              {label}
            </button>
          ))}
          <button data-testid="nav-tip-cta" onClick={() => go("tip")}
            className="rounded-full bg-[#e3ba73] text-[#121016] px-5 py-2 text-sm font-semibold hover:bg-[#f4d79e] transition-colors duration-300">
            Support my writing
          </button>
        </nav>
        <button data-testid="nav-mobile-toggle" className="md:hidden p-2" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden border-t border-[#e3ba73]/10 bg-[#121016] px-5 py-4 flex flex-col gap-1">
          {LINKS.map(([id, label]) => (
            <button key={id} data-testid={`nav-mobile-${id}-link`} onClick={() => go(id)} className="text-left py-3 font-serif-d text-2xl">
              {label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
